import { ref } from 'vue'

export enum GalleryTypes {
  PHOTO,
  VIDEO,
  AUDIO,
  LINK,
  DOC,
  FILE,
  PARTICIPANTS,
}

export const type = ref<GalleryTypes>(GalleryTypes.PHOTO)
